import { breakpoints } from 'styles';

export function isMobile(): boolean {
  const { innerWidth: width } = window;
  return width < parseInt(breakpoints.intermediary, 10);
}
